module.exports = __webpack_public_path__ + "static/media/icon-graphic-rocket.c4a35392.svg";